import React, { PureComponent } from "react";
import Select from "react-select";

import numeral from "numeral";

import Slider, { Range } from "rc-slider";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";
import { Popover, OverlayTrigger, Modal } from "react-bootstrap";
import { LineInput } from "components/Inputs/LineInput";
import Toggle from "react-toggle";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import TinyBarChart from "components/Project/TinyBarChart";
import PieChart from "components/Project/PieChart";

import LightningBoltIcon from "images/lightningbolt.svg";
import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";

import ModelBoxContainer from "containers/Business/ModelBox/ModelBox";
import ModelContainer from "containers/Business/ModelBox/Model";
import ModelLabels from "components/Business/ModelBox/ModelLabels";
import ImpactSlider from "components/Optimizer/ImpactSlider";

import OptimizeWarnings from "components/UnifiedProject/Optimize/Double/OptimizeWarnings";
import ContinuousAssumptionsCardContainer from "containers/UnifiedProject/Optimize/Subcontainers/ContinuousAssumptionsCard";

import RealityCheckContainer from "containers/Business/RealityCheck/RealityCheck";

import ProjectHelp from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import { SegmentMetric } from "utils/optimizer/ProjectOptimizer";

import * as projectReducer from "containers/Project/reducer";

import BusinessConstraints from "containers/Business/Strategy/BusinessConstraints";
import Introspect from "containers/Next/Strategy/Introspect";

import styles from "./style.module.css";

export default class NextStrategy extends React.PureComponent {
  constructor(props) {
    super(props);

    const { setup } = this.props;

    this.state = {
      isHammer: false
    };

    this.realityHammerRef = React.createRef();
    this.strategySection = React.createRef();
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  // Uses subgroup counts to make overall counts if overall
  getCounts(isBaseline = false) {
    const { setup, modelGroups } = this.props;
    if (!this.getIsOverallSegment()) {
      const countsObj = isBaseline && setup.isRealityHammer && setup.baselineCounts ? setup.baselineCounts : setup;
      return {
        truePositive: Number(countsObj.truePositive),
        falsePositive: Number(countsObj.falsePositive),
        trueNegative: Number(countsObj.trueNegative),
        falseNegative: Number(countsObj.falseNegative)
      };
    }
    const retCounts = {
      truePositive: 0,
      falsePositive: 0,
      trueNegative: 0,
      falseNegative: 0
    };
    modelGroups.drilldownValues
      .filter((d) => d.value !== "Overall")
      .map((d) => d.setup)
      .forEach((currSetup) => {
        const countsObj =
          isBaseline && currSetup.isRealityHammer && currSetup.baselineCounts ? currSetup.baselineCounts : currSetup;
        retCounts.truePositive = retCounts.truePositive + Number(countsObj.truePositive);
        retCounts.falsePositive = retCounts.falsePositive + Number(countsObj.falsePositive);
        retCounts.trueNegative = retCounts.trueNegative + Number(countsObj.trueNegative);
        retCounts.falseNegative = retCounts.falseNegative + Number(countsObj.falseNegative);
      });
    return retCounts;
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts(true);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  renderBaselineReset(clickable = true) {
    const { setup, isRealityHammer, updateOutcomePercentage, updateIsRealityHammer, runId } = this.props;

    const baselines = this.getBaselines();

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const handleReset = () => {
      if (!clickable) {
        return null;
      }

      if (isRealityHammer) {
        updateOutcomePercentage(runId, Number(baselines.baselineWinRate / 100));
      } else {
        updateIsRealityHammer(runId, true);
        updateOutcomePercentage(runId, Number(baselines.baselineWinRate / 100));
      }
    };

    if (totalWinRate !== baselines.baselineWinRate) {
      return (
        <a onClick={() => handleReset()} style={{ color: "#7E69D7" }}>
          {" (In Data " + baselines.baselineWinRate + "%)"}
        </a>
      );
    }
    return " (In Data " + baselines.baselineWinRate + "%)";
  }

  renderRealityHammer() {
    const {
      optimizer,
      setup,
      hasLinkedProject,
      optimized,
      setupLabels,
      isContinuous,
      isRealityHammer,
      runId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateShowImpact,
      modelGroups,
      updateDrilldownValue,
      costLabel,
      profitLabel,
      revenueLabel
    } = this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const isOverallSegment = this.getIsOverallSegment();

    const baselines = this.getBaselines();

    const outcome = setupLabels && setupLabels.outcomeLabel ? setupLabels.outcomeLabel : "Success";

    let objective;

    if (setup && setup.primaryBusinessConstraintType) {
      const currentObjective = setup.primaryBusinessConstraintType;
      switch (currentObjective) {
        case "profit":
          objective = profitLabel;
          break;
        case "revenue":
          objective = revenueLabel;
          break;
        case "cost":
          objective = costLabel;
          break;
      }
    }

    const renderOverallSection = () => {
      const modelGroupSegments =
        modelGroups &&
        modelGroups.drilldownValues &&
        modelGroups.drilldownValues.filter((model) => model.column !== "Overall");

      const allBusinessImpactsEnabled =
        modelGroupSegments.filter((group) => group.setup && !group.setup.showImpact).length === 0;

      const renderSegments = () => {
        const segments = modelGroupSegments.map((group, index) => {
          const businessImpactReviewed = group.setup && group.setup && group.setup.showImpact;

          const handleUpdateImpact = async () => {
            if (!businessImpactReviewed) {
              await updateShowImpact(group.runId, true);
            }
            if (group.runId) {
              updateDrilldownValue(group.runId, group.value);
            }
          };

          return (
            <div className={styles.realityHammerItem} key={index}>
              <a
                style={{
                  color: "#7E69D7",
                  display: "flex",
                  alignItems: "center"
                }}
                onClick={handleUpdateImpact}
              >
                {businessImpactReviewed ? (
                  <Icon type={"check"} isRound background={"green"} size={23} style={{ marginRight: "5px" }} />
                ) : (
                  <img src={LightningBoltIcon} className={styles.lightningIcon} />
                )}
                {businessImpactReviewed ? `${group.label} has been set` : `Review ${group.label}`}
              </a>
            </div>
          );
        });

        return segments;
      };

      return (
        <React.Fragment>
          <div className={styles.realityHammerItem}>
            {allBusinessImpactsEnabled ? (
              <React.Fragment>{this.renderAssumptions()}</React.Fragment>
            ) : (
              <React.Fragment>
                <div className={styles.strategyTitle}>
                  {objective
                    ? `Add Your Expected Business Drivers to Find Optimal ${objective}`
                    : `Add Your Expected Business Drivers`}
                </div>
                {false && renderSegments()}
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      );
    };

    return (
      <React.Fragment>
        {this.getIsOverallSegment() ? (
          <React.Fragment>{renderOverallSection()}</React.Fragment>
        ) : (
          <React.Fragment>
            {!setup.showImpact && false && <div style={{ fontWeight: "bold" }}>Want to calculate a $ impact?</div>}
            <React.Fragment>
              <div className={styles.realityHammerItem}>
                <div className={styles.aHeader}>
                  <div className={styles.aCol}>{"Assumptions"}</div>
                  <div className={styles.aCol}>{"Scenario"}</div>
                </div>
                <div className={styles.strategyContent}>
                  {isOverallSegment ? this.renderAssumptions() : this.renderCosts()}
                </div>
              </div>
              <OptimizeWarnings setup={setup} isContinuous={isContinuous} />
            </React.Fragment>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  renderCustomCosts() {
    const { id, runId, setup, optimized, blueprint, customMappings, updateCustomValue } = this.props;

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    return (
      <div className={styles.costsHolder}>
        <div className={styles.aHolder}>
          {Object.keys(setup.customValues).map((v, i) => {
            const showWarning =
              optimized &&
              optimized.setup &&
              optimized.setup.customValues &&
              optimized.originalSetup &&
              optimized.originalSetup.customValues
                ? checkValueWarning(optimized.setup.customValues[v], optimized.originalSetup.customValues[v])
                : false;

            const bpDesc =
              blueprint &&
              blueprint &&
              blueprint.wizard &&
              blueprint.wizard.customFields &&
              blueprint.wizard.customFields[v] &&
              blueprint.wizard.customFields[v].desc
                ? blueprint.wizard.customFields[v].desc
                : v;

            const currMapping = customMappings && customMappings[v];

            return (
              <React.Fragment key={v + i}>
                <div className={styles.assumptionEditItem}>
                  <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                    <OverlayTrigger
                      placement={"top"}
                      trigger={["hover", "focus"]}
                      containerPadding={20}
                      overlay={
                        <Popover
                          id={"popover-positioned-top"}
                          title={
                            currMapping ? (
                              <div>
                                <span>{"Using values from the field "}</span>
                                <strong>{currMapping}</strong>
                              </div>
                            ) : undefined
                          }
                        >
                          {bpDesc}
                        </Popover>
                      }
                    >
                      <span>{v}</span>
                    </OverlayTrigger>
                  </div>
                  <div className={styles.costEditThirdsThree}>
                    <OverlayTrigger
                      placement="top"
                      trigger={currMapping ? ["hover"] : []}
                      rootClose
                      overlay={
                        <Popover id="popover-positioned-top">
                          {/* TODO: Add the specific column selected and the average value. Change message based on whether the user has changed the average value. */}
                          <div className={styles.tooltip} style={{ maxWidth: "300px" }}>
                            <span>
                              {
                                "Aible automatically populated this with the average value from the field you selected in the "
                              }
                            </span>
                            <strong>{"Business Assumption Field Mapping"}</strong>
                            <span>{" section of the "}</span>
                            <strong>{"Data Setup"}</strong>
                          </div>
                        </Popover>
                      }
                    >
                      <div className={styles.cFieldInput}>
                        <LineInput
                          isMediumBox
                          onChange={(val) => updateCustomValue(runId, setup.blueprintId, v, val)}
                          value={setup.customValues[v]}
                          style={{ color: "#4B495B" }}
                          isWarning={showWarning}
                          warning={
                            showWarning &&
                            getWarningMessage(
                              optimized.setup.customValues[v],
                              optimized.originalSetup.customValues[v],
                              "Scenario",
                              "Blueprint"
                            )
                          }
                        />
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }

  renderCosts() {
    const {
      setup,
      runId,
      setupLabels,
      optimized,
      isContinuous,
      updateTotal,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      blueprint
    } = this.props;

    const hasCustomValues =
      blueprint &&
      blueprint.wizard &&
      blueprint.wizard.customFields &&
      Object.keys(blueprint.wizard.customFields).length > 0;

    return hasCustomValues ? (
      this.renderCustomCosts()
    ) : (
      <div className={styles.costsHolder}>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{isContinuous ? setup.overestimateLabel : setup.truePositiveLabel}</div>
          <div className={styles.cOpt}>
            <LineInput isMediumBox value={setup.conversionGain} onChange={(val) => updateConversionGain(runId, val)} />
          </div>
        </div>
        <div className={styles.costOption}>
          <div className={styles.cLabel}>{isContinuous ? setup.underestimateLabel : setup.falsePositiveLabel}</div>
          <div className={styles.cOpt}>
            <LineInput
              isMediumBox
              value={isContinuous ? Math.abs(setup.conversionCost) : setup.conversionCost}
              onChange={(val) => updateConversionCost(runId, val)}
            />
          </div>
        </div>
        {!isContinuous ? (
          <React.Fragment>
            <div className={styles.costOption}>
              <div className={styles.cLabel}>{setup.trueNegativeLabel}</div>
              <div className={styles.cOpt}>
                <LineInput
                  isMediumBox
                  value={setup.conversionSaved}
                  onChange={(val) => updateConversionSaved(runId, val)}
                />
              </div>
            </div>
            <div className={styles.costOption}>
              <div className={styles.cLabel}>{setup.falseNegativeLabel}</div>
              <div className={styles.cOpt}>
                <LineInput
                  isMediumBox
                  value={setup.conversionMissed}
                  onChange={(val) => updateConversionMissed(runId, val)}
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }

  renderAssumptions() {
    const { id, setup, optimizer, optimized, isContinuous, modelGroups, updateDrilldownValue } = this.props;

    if (setup === undefined || Object.keys(setup).length === 0) {
      return <div />;
    }

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = hasCustomValues;

    return (
      <div className={styles.costsHolder}>
        <div className={styles.shareHeader}>
          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
            {"Assumptions"}
          </div>
          <div className={styles.costSectionTwo}>{"Distribution"}</div>
          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
            {"Average"}
          </div>
        </div>
        {showCustomValues ? (
          <div
            className={styles.oItemBotContent}
            style={{
              marginTop: "0px"
            }}
          >
            <div className={styles.aholder}>
              {Object.keys(optimized.setup.customValues).map((c, i) => {
                const bpDesc =
                  optimized &&
                  optimized.blueprint &&
                  optimized.blueprint &&
                  optimized.blueprint.wizard &&
                  optimized.blueprint.wizard.customFields &&
                  optimized.blueprint.wizard.customFields[c] &&
                  optimized.blueprint.wizard.customFields[c].desc
                    ? optimized.blueprint.wizard.customFields[c].desc
                    : c;

                return (
                  <div key={i} className={styles.assumptionItem}>
                    <div className={styles.costSectionOne} title={bpDesc}>
                      {c}
                    </div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.customValues[c],
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.customValues[c]}
                        drilldownValue={optimizer?.drilldownValue}
                        updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.customValues[c] !== undefined
                        ? Number(optimized.setup.customValues[c]).toFixed(2)
                        : ""}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            {modelGroups && modelGroups.drilldownValues && (
              <div
                className={styles.oItemBotContent}
                style={{
                  marginTop: "0px"
                }}
              >
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionGain,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionGain}
                      drilldownValue={optimizer?.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionGain !== undefined
                      ? Number(optimized.setup.conversionGain).toFixed(2)
                      : ""}
                  </div>
                </div>
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionCost,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionCost}
                      drilldownValue={optimizer?.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionCost !== undefined
                      ? Number(optimized.setup.conversionCost).toFixed(2)
                      : ""}
                  </div>
                </div>
                {!isContinuous ? (
                  <React.Fragment>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionSaved,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionSaved}
                          drilldownValue={optimizer?.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionSaved !== undefined
                          ? Number(optimized.setup.conversionSaved).toFixed(2)
                          : ""}
                      </div>
                    </div>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionGain,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionMissed}
                          drilldownValue={optimizer?.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionMissed !== undefined
                          ? Number(optimized.setup.conversionMissed).toFixed(2)
                          : ""}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderOverallContent() {
    const { id, optimized, runId, setup, modelGroups, updateDrilldownValue, setupLabels, businessMode, overallSetup } =
      this.props;

    const overallOnly = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length < 2;

    const isOverallSegment = this.getIsOverallSegment();

    const currentSegment =
      (modelGroups &&
        modelGroups.drilldownValues &&
        modelGroups.drilldownValues.find((group) => group.runId === runId)) ||
      {};

    const scrollToRealityHammer = () => {
      this.realityHammerRef.current.scrollIntoView({ behavior: "smooth" });
    };

    return (
      <div className={styles.overall}>
        <div className={styles.pTitle} style={{ marginTop: "20px", marginBottom: "5px" }} ref={this.strategySection}>
          {isOverallSegment || overallOnly
            ? "Set Your Business Strategy to Guide your Optimal AI"
            : `Set Your Business Strategy to Guide your Optimal AI for ${currentSegment.label}`}
        </div>
        <div className={styles.optionHolder}>
          <BusinessConstraints
            id={id}
            setupLabels={setupLabels}
            overallOnly={overallOnly}
            currentSegment={currentSegment}
          />
        </div>
      </div>
    );
  }

  renderAdvancedRealityHammer() {
    const {
      optimizer,
      setup,
      hasLinkedProject,
      optimized,
      setupLabels,
      isRealityHammer,
      isOverallSegment,
      isContinuous,
      id,
      runId,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateShowImpact,
      modelGroups,
      updateDrilldownValue,
      costLabel,
      profitLabel,
      revenueLabel
    } = this.props;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const { truePositive, falsePositive, trueNegative, falseNegative } = this.getCounts();
    const pursued = Number(truePositive) + Number(falsePositive);
    const notPursued = Number(trueNegative) + Number(falseNegative);
    const total = pursued + notPursued;

    const positives = Number(truePositive) + Number(falseNegative);
    const negatives = Number(falsePositive) + Number(trueNegative);

    const totalWinRate =
      positives + negatives !== 0
        ? ((positives / (positives + negatives)) * 100).toFixed(2)
        : setup.outcomePercentage === undefined
          ? 0
          : setup.outcomePercentage * 100;

    const baselines = this.getBaselines();

    const outcome = setupLabels && setupLabels.outcomeLabel ? setupLabels.outcomeLabel : "Success";

    return (
      <div
        className={styles.eBotItem}
        style={{
          padding: "0px"
        }}
      >
        {!optimized ? (
          <div />
        ) : isContinuous ? (
          <ContinuousAssumptionsCardContainer id={id} />
        ) : (
          <React.Fragment>
            {isOverallSegment === true ? (
              <div />
            ) : (
              <div
                className={styles.aHeader}
                style={{
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  padding: "20px"
                }}
              >
                <div
                  style={{
                    width: "calc(100% - 75px"
                  }}
                >
                  {"Will future " +
                    transactionLabel +
                    " and " +
                    outcomeLabel +
                    " rate match the baseline behavior assumptions?"}
                </div>
                <div style={{ width: "100px" }}>
                  <div id={"eToggle"} className={styles.tHolder}>
                    <Toggle
                      checked={isRealityHammer === true}
                      icons={false}
                      onChange={(e) => updateIsRealityHammer(runId, !isRealityHammer)}
                    />
                    <span className={isRealityHammer === true ? styles.yPos : styles.nPos}>
                      {isRealityHammer !== true ? "Yes" : "No"}
                    </span>
                  </div>
                </div>
              </div>
            )}
            {optimized ? (
              <div className={styles.wQuestion}>
                <div className={styles.rHammer}>
                  <span>
                    <span>{"Potential "}</span>
                    <span
                      style={{
                        fontWeight: "bold"
                      }}
                    >
                      {transactionLabel}
                    </span>
                    <span>{" the AI will predict"}</span>
                  </span>
                  <div className={styles.wInput}>
                    <LineInput
                      isMediumBox
                      value={Math.round(total)}
                      isDisabled={isRealityHammer !== true}
                      onChange={(val) => {
                        if (!isNaN(val)) {
                          updateScaledTotal(runId, Number(val));
                        }
                      }}
                      style={{
                        color: "#4B495B"
                      }}
                    />
                    <div
                      style={{
                        marginRight: "15px"
                      }}
                    >
                      {" with a "}
                    </div>
                    <div
                      style={{
                        width: "80px"
                      }}
                    >
                      <LineInput
                        isMediumBox
                        value={totalWinRate}
                        isDisabled={isRealityHammer !== true}
                        onChange={(val) => {
                          if (!isNaN(val)) {
                            updateOutcomePercentage(runId, Number(val) / 100);
                          }
                        }}
                        style={{
                          color: "#4B495B"
                        }}
                      />
                    </div>
                    <div
                      style={{
                        marginLeft: "-6px"
                      }}
                    >
                      {"% potential " + outcomeLabel + " rate"}
                    </div>
                  </div>
                </div>
                {isRealityHammer === true &&
                  baselines &&
                  baselines.baselineTotal !== undefined &&
                  baselines.baselineTotal !== total && (
                    <div className={styles.overwrote}>
                      {"Original Baseline"}
                      <div className={styles.wInput}>
                        <LineInput
                          isMediumBox
                          value={baselines && baselines.baselineTotal !== undefined ? baselines.baselineTotal : total}
                          isDisabled={true}
                          onChange={(val) => {
                            !isNaN(val) && updateScaledTotal(runId, Number(val));
                          }}
                          style={{
                            color: "#4B495B"
                          }}
                        />
                        <div
                          style={{
                            marginRight: "15px"
                          }}
                        >
                          {" with a "}
                        </div>
                        <div
                          style={{
                            width: "80px"
                          }}
                        >
                          <LineInput
                            isMediumBox
                            value={
                              baselines && baselines.baselineWinRate !== undefined
                                ? baselines.baselineWinRate
                                : totalWinRate
                            }
                            isDisabled={true}
                            onChange={(val) => {
                              !isNaN(val) && updateOutcomePercentage(runId, Number(val) / 100);
                            }}
                            style={{
                              color: "#4B495B"
                            }}
                          />
                        </div>
                        <div
                          style={{
                            marginLeft: "-6px"
                          }}
                        >
                          {"% potential " + outcomeLabel + " rate"}
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            ) : (
              <div />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }

  render() {
    const { id, runId, isNext, businessMode, modelGroups, optimized, hideModel, isOverallSegment, isOnlyReality } =
      this.props;

    if (isOnlyReality === true) {
      return this.renderAdvancedRealityHammer();
    }

    const overallOnly = modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues.length < 2;
    const styles = isNext
      ? { width: "100%", padding: "0px 20px" }
      : hideModel
        ? { width: "400px", padding: "10px" }
        : {};
    return (
      <div
        className={styles.pHolder + " " + (!overallOnly && !this.getIsOverallSegment() ? styles.isWide : "")}
        style={styles}
      >
        {isOverallSegment === true ? (
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              fontSize: "16px",
              display: "flex",
              alignItems: "center"
            }}
          >
            <Icon type={"info"} />
            <div style={{ marginLeft: "8px" }}>{"Select a subgroup to update expected behavior"}</div>
          </div>
        ) : (
          <div />
        )}
        {isNext !== true && this.renderOverallContent()}
        <div className={isNext ? styles.nextOptionHolder : styles.optionHolder}>{this.renderRealityHammer()}</div>
        {isOverallSegment === true && this.renderAssumptions()}
        <div style={{ marginTop: "10px" }} />
        {this.renderAdvancedRealityHammer()}
        {hideModel !== true && (
          <div className={styles.mBox} style={isNext ? { left: "27%", top: "110px", width: "440px" } : {}}>
            <ModelBoxContainer
              id={id}
              runId={runId}
              isSmall={overallOnly || this.getIsOverallSegment()}
              showSubgroup={!overallOnly && !this.getIsOverallSegment()}
              strategy
            />
          </div>
        )}
      </div>
    );
  }
}
